import React from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'

const isElectron = Boolean(window.todesktop)
function ExternalLink ({ children, url, className }) {
  return (
    isElectron ? (<a className={className} css={css`&:hover { text-decoration: underline; }`} onClick={() => {
      window.todesktop.contents.openUrlInBrowser(url)
    }}>{children}</a>) : (<a className={className} css={css`&:hover { text-decoration: underline; }`} href={url} target={'_blank'}>{children}</a>)
  )
}

export default ExternalLink
